import ButtonPlus from "../../../../../common/components/atom/ButtonPlus/ButtonPlus";
import useQueryURL from "../../../../../common/hooks/useQueryURL";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";

export default function AddNewConnectorBtn({
  modalId = "new-connector-modal",
}: {
  modalId?: string;
}) {
  const { setQueryValue } = useQueryURL();
  const { userRole } = useAuth();
  const handleClick = () => {
    setQueryValue({
      [modalId]: "true",
    });
  };

  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }
  return <ButtonPlus label="Ajouter un connecteur" onClick={handleClick} />;
}
